var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTree(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.8 2.8C8.8 3.27739 8.61036 3.73523 8.27279 4.07279C7.93523 4.41036 7.47739 4.6 7 4.6C6.52261 4.6 6.06477 4.41036 5.72721 4.07279C5.38964 3.73523 5.2 3.27739 5.2 2.8C5.2 2.32261 5.38964 1.86477 5.72721 1.52721C6.06477 1.18964 6.52261 1 7 1C7.47739 1 7.93523 1.18964 8.27279 1.52721C8.61036 1.86477 8.8 2.32261 8.8 2.8ZM4.6 11.2C4.6 11.6774 4.41036 12.1352 4.07279 12.4728C3.73523 12.8104 3.27739 13 2.8 13C2.32261 13 1.86477 12.8104 1.52721 12.4728C1.18964 12.1352 1 11.6774 1 11.2C1 10.7226 1.18964 10.2648 1.52721 9.92721C1.86477 9.58964 2.32261 9.4 2.8 9.4C3.27739 9.4 3.73523 9.58964 4.07279 9.92721C4.41036 10.2648 4.6 10.7226 4.6 11.2ZM13 11.2C13 11.6774 12.8104 12.1352 12.4728 12.4728C12.1352 12.8104 11.6774 13 11.2 13C10.7226 13 10.2648 12.8104 9.92721 12.4728C9.58964 12.1352 9.4 11.6774 9.4 11.2C9.4 10.7226 9.58964 10.2648 9.92721 9.92721C10.2648 9.58964 10.7226 9.4 11.2 9.4C11.6774 9.4 12.1352 9.58964 12.4728 9.92721C12.8104 10.2648 13 10.7226 13 11.2Z",
    stroke: "#5A8DF1",
    strokeWidth: 1.41176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.00469 4.86719V7.00156M7.00469 7.00156H4.90469C3.91469 7.00156 3.41969 7.00156 3.11249 7.26556C2.80469 7.52836 2.80469 7.95256 2.80469 8.80156V9.40156M7.00469 7.00156H9.10469C10.0947 7.00156 10.5897 7.00156 10.8969 7.26556C11.2047 7.52836 11.2047 7.95256 11.2047 8.80156V9.40156",
    stroke: "#5A8DF1",
    strokeWidth: 1.41176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTree);
export default __webpack_public_path__ + "static/media/ic_tree.8e8a274316f80c1c0f95a2e2c99d189a.svg";
export { ForwardRef as ReactComponent };